import React from "react";
import { withRouter, useParams } from "react-router-dom";
import { v4 } from "uuid";
import withDefaultParams from "Services/withDefaultParams";

const SeoTextExclusive = props => {
    let { siteCode, region, tariffInfo } = props;

    const speedMeasure = () => {
        return `<span style="white-space: nowrap">Мбит/с</span>`;
    };

    const exclusive101 = () => {
        let textChannel = () => {
            return `
            <p>Кроме того, при подключении ${
                tariffInfo.tariffsNameListChannel.length === 1
                    ? "тарифа"
                    : "тарифов"
            } ${tariffInfo.tariffsNameListChannel.join(
                ", "
            )} вы получите доступ к каналам телевидения и сможете наслаждаться фильмами и любимыми программами по тв.</p>
            `;
        };
        let textMobile = () => {
            return `
                <p>А ещё в ${
                    tariffInfo.tariffsNameListMobile.length === 1
                        ? "тарифе"
                        : "тарифах"
                } ${tariffInfo.tariffsNameListMobile.join(
                ", "
            )} доступны услуги мобильной связи и интернета. Это значит, что при подключении вы получите не только домашний интернет, но и мобильную связь и интернет для вашего смартфона. И всё это по цене всего от ${
                tariffInfo.minPrice
            } рублей в месяц.</p>
            `;
        };

        return `
<p>Дешёвый домашний интернет любят все. Особенно когда это качественное и стабильное подключение с хорошей скоростью по выгодной цене.</p>
<p>Именно поэтому мы собрали в одном месте все самые выгодные тарифы с интернетом для дома в ${
            region.declinations.prepositional
        }. Теперь все предложения доступны вам в виде удобной таблицы.</p>
<p>В чём же ${
            tariffInfo.providersNameList.length === 1
                ? "преимущество"
                : "преимущества"
        } ${tariffInfo.providersNameList.join(", ")}?</p>
<ul>
<li>отличная скорость интернета ${
            tariffInfo.internetSpeedMin !== tariffInfo.internetSpeedMax
                ? `от ${tariffInfo.internetSpeedMin}`
                : ""
        } до ${
            tariffInfo.internetSpeedMax
        } ${speedMeasure()} — вам не придётся больше переживать о том, что сериал зависнет на самом интересном месте;</li>
<li>стабильное подключение;</li>
<li>качественный сервис техподдержки.</li>
</ul>
${!!tariffInfo.tariffsNameListChannel.length ? `${textChannel()}` : ""}
${!!tariffInfo.tariffsNameListMobile.length ? `${textMobile()}` : ""}
<p>Выгодные предложения с домашним интернетом — это отличный повод сменить тариф или провайдера на более подходящий. Тем более что для этого достаточно всего лишь оставить заявку на нашем сайте.</p>
        `;
    };

    const exclusiveMoskva = () => {
        let textRouter = () => {
            return `
                <p>Кроме того, при подключении ${
                    tariffInfo.tariffsNameListRouter.length === 1
                        ? "тарифа"
                        : "тарифов"
                } ${tariffInfo.tariffsNameListRouter.join(
                ", "
            )}, вы получите возможность приобрести или арендовать роутер на выгодных условиях. А значит, не придётся тратить время на то, чтобы покупать его отдельно.</p>
            `;
        };
        return `
<p>Многие пользователи предпочитают дешёвый домашний интернет. Особенно когда это качественное и стабильное подключение с хорошей скоростью по выгодной цене.</p>
<p>Выгодные тарифы от ${tariffInfo.providersNameList.join(
            ", "
        )} включают в себя высокоскоростное подключение к домашнему интернету, доступ к телевизионным каналам, а также пакеты минут разговора и смс (доступно не для всех тарифов).</p>
<p>А вот то, что вас ожидает абсолютно в каждом тарифе:</p>
<ul>
<li>отличная скорость интернета ${
            tariffInfo.internetSpeedMin !== tariffInfo.internetSpeedMax
                ? `от ${tariffInfo.internetSpeedMin}`
                : ""
        } до ${
            tariffInfo.internetSpeedMax
        } ${speedMeasure()} — скачивайте файлы, смотрите фильмы — скорости хватит на всё;</li>
<li>стабильное подключение — ничего не помешает вашему разговору с родными и близкими;</li>
<li>качественный сервис техподдержки.</li>
</ul>
${!!tariffInfo.tariffsNameListRouter.length ? `${textRouter()}` : ""}
<p>Выгодные предложения с домашним интернетом — это отличный повод сменить тариф или провайдера на более подходящий и не переплачивать за ненужные услуги.</p>
<p>Чтобы ваш выбор стал ещё проще и удобнее, мы собрали все предложения в одну табличку. Выберите и сравните подходящие тарифы, а затем оставьте заявку на подключение прямо на нашем сайте.</p>
        `;
    };

    const exclusivePiter = () => {
        let textMobile = () => {
            return `
                <p>А при подключении ${
                    tariffInfo.tariffsNameListMobile.length === 1
                        ? "тарифа"
                        : "тарифов"
                } ${tariffInfo.tariffsNameListMobile.join(
                ", "
            )} вы получите полный комплект услуг, включающий не только домашний интернет, но и мобильную связь и смс.</p>
            `;
        };
        let textRouter = () => {
            return `
                <p>Кроме того, при подключении ${
                    tariffInfo.tariffsNameListRouter.length === 1
                        ? "тарифа"
                        : "тарифов"
                } ${tariffInfo.tariffsNameListRouter.join(
                ", "
            )}, вы получите возможность приобрести или арендовать роутер на выгодных условиях. А значит, не придётся тратить время на то, чтобы покупать его отдельно.</p>
            `;
        };

        return `
<p>Все мы любим выгодные предложения. Особенно когда речь идёт о дешёвом домашнем интернете. Учитывая, что интернет-подключение необходимо и для работы, и для учёбы, и для общения, хочется найти тариф с качественным и быстрым соединением за разумные деньги.</p>
<p>Выгодные тарифы от ${tariffInfo.providersNameList.join(
            ", "
        )} включают в себя подключение к домашнему интернету на скорости ${
            tariffInfo.internetSpeedMin !== tariffInfo.internetSpeedMax
                ? `от ${tariffInfo.internetSpeedMin}`
                : ""
        } до ${
            tariffInfo.internetSpeedMax
        } ${speedMeasure()}. При этом стоимость начинается всего от ${
            tariffInfo.minPrice
        } рублей в месяц.</p>
${!!tariffInfo.tariffsNameListMobile.length ? `${textMobile()}` : ""}
<p>Помимо этого, в каждом тарифе вас ожидают:</p>
<ul>
<li>отличная скорость интернета;</li>
<li>стабильное подключение;</li>
<li>качественный сервис техподдержки.</li>
</ul>
${!!tariffInfo.tariffsNameListRouter.length ? `${textRouter()}` : ""}
<p>Выгодные предложения с домашним интернетом — это отличный повод сменить тариф или провайдера на более подходящий и не переплачивать за ненужные услуги.</p>
<p>Чтобы ваш выбор стал ещё проще и удобнее, мы собрали все предложения в одну табличку. Выберите подходящий, а затем оставьте заявку на подключение прямо на нашем сайте.</p>
        `;
    };

    let siteCodeName = {
        "101internet": exclusive101,
        moskvaonline: exclusiveMoskva,
        piteronline: exclusivePiter,
    };

    let seoTextView = siteCodeName[siteCode];

    if (!!seoTextView) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: seoTextView(),
                }}
            />
        );
    } else {
        return null;
    }
};

export default withRouter(withDefaultParams(SeoTextExclusive));
